import { render, staticRenderFns } from "./OrderTemplate.vue?vue&type=template&id=f20d0a66&scoped=true&"
import script from "./OrderTemplate.vue?vue&type=script&lang=js&"
export * from "./OrderTemplate.vue?vue&type=script&lang=js&"
import style0 from "./OrderTemplate.vue?vue&type=style&index=0&id=f20d0a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20d0a66",
  null
  
)

export default component.exports